<app-infractions-view [userRutDv]="userRutDv" [requestType]="'search'" (showForm)="onSelectInfringement($event)" [ngClass]="{'show' : !showNewInfraction , 'hide' : showNewInfraction}"></app-infractions-view>

<div *ngIf="showNewInfraction">
    <a *ngIf="selectedInfringement" class="back u-mb40 toggle global-hand" (click)="onHideForm()"> Infracción N° {{ selectedInfringement}} </a>
    <a *ngIf="!selectedInfringement" class="back u-mb40 toggle global-hand" (click)="onHideForm()"> Nueva Infracción </a>

    <div class="loader" *ngIf="gettingInfringementDetail">
        <app-loader></app-loader>
    </div>

    <div class="global-full-width" [ngClass]="{'show' : !gettingInfringementDetail && gettinInfringementDetailError === 'DEFAULT_VALUE', 'hide' : gettingInfringementDetail || gettinInfringementDetailError !== 'DEFAULT_VALUE'}">
        <div class="container">
          <div class="">
            <app-form-location-and-equipment [controlForm]="formGroupLocationAndEquipment" [formNumber]="1">
            </app-form-location-and-equipment>
            <div [ngClass]="!formGroupLocationAndEquipment.valid ? 'u-lock' : ''">
              <app-form-detail [formNumber]="2" (emmitSeverityName)="onChangeSeverity($event)"
              (emmitInfrigmentTypeName)="onChangeInfringement($event)" [controlForm]="formGroupDetail"
                [assetId]="assetId"></app-form-detail>
            </div>
          </div>
          <div class="u-mt50" [ngClass]="formGroupDetail.valid && recommendation ? '' : 'u-lock'">
            <app-form-type-sanction [formNumber]="3" [infrigementName]="infrigementName" [severityName]="severityName"
              [recommendation]="recommendation" [assetId]="assetId" [controlForm]="formGroupSanctionType"
              class="global-full-width">
            </app-form-type-sanction>
            <div class="request__send u-bt u-bt--grey u-pt20 u-mt20 u-mb20">
              <div class="buttons u-mt20">
                <div class="row">
                   <div class="col-md-3 order-md-1 order-2">
                    <a class="btn btn--link" (click)="onDisable()">Eliminar infracción</a>
                  </div>
                  <div class="col-md-9 order-md-2 order-1">
                    <button type="button" class="btn btn--primary modal__trigger" data-modal="modal02"
                      [disabled]="form.valid ? false : true" (click)="onSubmit()">Registrar
                      infracción</button>
                  </div>
                </div>
          </div>

        </div>
      </div>
</div>
